import { useTranslation } from 'react-i18next'
import { Link, useLocation } from 'react-router'
import { Button } from '@structural-climbing/ui'

/**
 * Shown to a member whose email address has not been proved by a code. Most of
 * them joined, and signed, before that was asked of anyone. It takes them to
 * the personal details page's email section, which opens the code step and brings them back.
 *
 * Same shape as `PhoneNeededBanner` on purpose: it is the same kind of ask.
 */
export function EmailVerificationBanner() {
  const { t } = useTranslation()
  const { pathname } = useLocation()
  const to = `/profile/details?${new URLSearchParams({ field: 'email', returnTo: pathname }).toString()}`

  return (
    <div className="bg-[var(--gym-page)] px-4 pt-4">
      <div
        role="status"
        className="mx-auto w-full max-w-xl overflow-hidden rounded-2xl border border-divider bg-content1 shadow-sm"
      >
        <div className="flex flex-col gap-3 border-l-4 border-warning bg-warning/10 p-4 sm:flex-row sm:items-center">
          <p className="flex-1 text-sm font-medium">{t('emailCode.bannerText')}</p>
          <Button
            as={Link}
            to={to}
            color="primary"
            variant="flat"
            className="shrink-0 font-semibold"
          >
            {t('emailCode.bannerCta')}
          </Button>
        </div>
      </div>
    </div>
  )
}
